import { render, staticRenderFns } from "./CustomerDetailsBar.vue?vue&type=template&id=6be2ea58&scoped=true"
import script from "./CustomerDetailsBar.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsBar.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsBar.vue?vue&type=style&index=0&id=6be2ea58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2ea58",
  null
  
)

export default component.exports